import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "./";

interface BelkaWatcherProps {
    location: string;
}

const BelkaWatcher = observer(({ location }: BelkaWatcherProps) => {
    const { UIStore } = useStores();

    useEffect(() => {
        UIStore.showSponsorshipTopBar();
    }, [location]);

    return null;
});

export default BelkaWatcher;